import { render, staticRenderFns } from "./Three.vue?vue&type=template&id=87ca158e&scoped=true"
import script from "./Three.vue?vue&type=script&lang=js"
export * from "./Three.vue?vue&type=script&lang=js"
import style0 from "./Three.vue?vue&type=style&index=0&id=87ca158e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ca158e",
  null
  
)

export default component.exports